export const primaryColor = '#4098ef';
export const primaryColorLight = '#96c4f0';
export const primaryColorLightHover = '#7fb6ec';
// Texto sobre o azul suave (#96c4f0) — par do PrimaryOnDarkButton (FC7).
export const onPrimaryLightColor = '#12314f';
export const primaryDarkColor = '#373737';
export const lightGrayColor = '#bfbfbf';
export const lightBgText = '#e5e5e5';

// FC7 — sistema semântico de ações (botões/links)
export const actionWriteColor = '#4098ef'; // azul claro: ação que escreve no banco
export const actionWriteColorHover = '#2581e0';
export const ctaDarkColor = '#1f1f18'; // CTA escuro: consulta/navegação
export const ctaDarkColorHover = '#3a3a31';
export const linkColor = '#185FA5'; // hyperlink de texto (contraste p/ leitura)
export const linkColorHover = '#134d86';

export const sucessColor = '#0197F6';
export const infoColor = '#d1a02e';
export const infoColorHover = '#e3ae32';
export const errorColor = '#ab2020';
export const errorColorHover = '#bf2a2a';
export const warningColor = '#F2AF29';
